import { TableColumn } from "react-data-table-component";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import { IConfig, IEventNotification } from "src/services/types";
import { X, Check, CornerUpLeft, MoreVertical, CornerUpRight, ArrowRight, MessageSquare } from 'feather-icons-react';

import './style.css';
import { UserColumnItem } from "../Users/UserColumnItem";

export const columnsNotifications: (
    config: IConfig, 
    openModal: (item: IEventNotification) => void,
    onValidate: (item: IEventNotification) => void,
    onReject: (item: IEventNotification) => void,
    onMoveAGroup: (item: IEventNotification) => void,
    openNoteModal: (item: IEventNotification) => void,
    onMarkAsRead: (item: IEventNotification) => void,
    onReturnToReview: (item: IEventNotification) => void
) => TableColumn<IEventNotification>[] = 
(config, openModal, onValidate, onReject, onMoveAGroup, openNoteModal, onMarkAsRead, onReturnToReview) => {
      
    return (
[
    { 
      name: "N°",
      center: true,
      width: "70px",
      selector: (_, index, ) => (config.page-1)*config.per_page + (index! + 1),
    },
    {
        name: "USER",
        width: "200px",
        cell: function OrderItems(item) {
          return (
            <UserColumnItem
              item={item?.user}
              openModal={()=> openModal(item)}
              openNoteModal={()=> openNoteModal(item)}
            />
          );
        }
    },
    {
      name: "GROUP",
      width: "110px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <>
            {
              item?.user?.group ? (
                <small
                    className="p-2 rounded"
                    style={{ backgroundColor: item?.user?.group?.color || '#f5f5f5'}}
                >
                  <span>{item?.user?.group?.name ? (item?.user?.group.name.length > 10 ? item?.user?.group.name.slice(0, 9) + '...' : item?.user?.group.name) : '-'}</span>
                </small>
              ) : '-'
            }
          </>
        );
      },
    },
    {
      name: "EVENT",
      width: "200px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <div className="text-center" >
            { item?.event_type_description }
          </div>
        );
      },
    },
    {
      name: "READ",
      width: "120px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <div className="text-center p-2 rounded-3" style={{ backgroundColor: item?.read_at ? '#fff' : '#ffec00' }}>
            { item?.read_at ? item.read_at : 'No' }
          </div>
        );
      },
    },
    {
      name: "CREATED AT",
      width: "120px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <div className="text-center" >
            { item?.created_at }
          </div>
        );
      },
    },
    {
      name: "VERIFIED BY ADMIN",
      center: true,
      width: "150px",
      cell: function OrderItems(item) {
        return (
            <div
                className="px-3"
                style={{
                  height: '30px',
                  borderRadius: '5px',
                  backgroundColor: item?.user?.isVerifiedByAdmin === null ? '#f0f0f0' : item?.user?.isVerifiedByAdmin ? '#eef8f3' : '#fff1f0',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
            >
              {
                item?.user?.isVerifiedByAdmin === null ?
                <span className="text-secondary">Pending</span> :
                item?.user?.isVerifiedByAdmin ?
                <span className="text-success">Validated</span> :
                <span className="text-danger">Rejected</span>
              }
            </div>
        );
      },
    },
    {
      name: "MARK AS READ",
      center: true,
      width: "125px",
      cell: function OrderItems(item) {
          return (
            <>
              {
                item?.read_at ? (
                  <div className="text-center p-2 rounded-3">
                    <span className="text-secondary">Already read</span>
                  </div>
                ) : (
                  <button
                      type="button"
                      className="btn btn-success btn-sm waves-effect waves-light"
                      onClick={(e) => (onMarkAsRead(item), e.currentTarget.blur())}
                  >
                    <span>Mark as read </span>
                    <Check size="16"/>
                  </button>
                )
              }
            </>
          );
      },
    },
    {
      name: "OPTIONS",
      width: "100px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <UncontrolledDropdown
              className="me-2"
              direction="start"
          >
            <DropdownToggle
            caret
            className="btn btn-soft-info btn-sm waves-effect waves-light"
            >
            <MoreVertical size={'16px'}/>
            </DropdownToggle>
            <DropdownMenu>
                <DropdownItem onClick={() => openNoteModal(item)}>
                    <div className="d-flex align-items-center gap-2">
                      <MessageSquare size="16"/>
                      <span>
                        {item?.user?.note ? 'View/Edit note' : 'Add note'}
                      </span>
                    </div>
                </DropdownItem>
                <DropdownItem divider style={{margin: '5px'}}/>
                <DropdownItem onClick={() => onMoveAGroup(item)}>
                    <div className="d-flex align-items-center gap-2">
                    {item?.user?.group?.id ? <ArrowRight size="16"/> : <CornerUpRight size="16" />}
                    <span>{item?.user?.group?.id ? 'Change/remove group' : 'Assign group'}</span>
                    </div>
                </DropdownItem>
                {
                  item?.user?.isVerifiedByAdmin !== true && (
                    <>
                      <DropdownItem divider style={{margin: '5px'}}/>
                      <DropdownItem onClick={() => onValidate(item)}>
                          <div className="d-flex align-items-center gap-2">
                            <Check size="16"/>
                            <span>Validate user</span>
                          </div>
                      </DropdownItem>
                    </>
                  )
                }
                {
                  item?.user?.isVerifiedByAdmin === null && (
                    <>
                      <DropdownItem divider style={{margin: '5px'}}/>
                      <DropdownItem onClick={() => onReject(item)}>
                          <div className="d-flex align-items-center gap-2">
                            <X size="16"/>
                            <span>Rejected user</span>
                          </div>
                      </DropdownItem>
                    </>
                  )
                }
                {
                  item?.user?.isVerifiedByAdmin == false && (
                    <>
                      <DropdownItem divider style={{margin: '5px'}}/>
                      <DropdownItem onClick={() => onReturnToReview(item)}>
                          <div className="d-flex align-items-center gap-2">
                            <CornerUpLeft size="16"/>
                            <span>Return to review</span>
                          </div>
                      </DropdownItem>
                    </>
                  )
                }
            </DropdownMenu>
          </UncontrolledDropdown>
        )
      }
    }
  ]
)}